import { useState, useEffect } from "react";
import toast from "react-hot-toast";

import { motion } from "framer-motion";

import { BsCashCoin } from "react-icons/bs";
import { X } from "react-bootstrap-icons";

import { getDisplayPrice } from "../../../../helpers/helpers";

const GuessPriceModal = ({ guess, show, handleClose, onSubmit, property }) => {
    const [priceGuess, setPriceGuess] = useState(getDisplayPrice(property));
    const [reason, setReason] = useState("");

    const displayPrice = getDisplayPrice(property);

    useEffect(() => {
        if (show) {
            setPriceGuess(displayPrice);
        }
    }, [displayPrice, show]);

    useEffect(() => {
        if (show) {
            document.body.classList.add("modal-open");

            const backdrop = document.createElement("div");
            backdrop.className = "modal-backdrop fade show";
            document.body.appendChild(backdrop);
        } else {
            document.body.classList.remove("modal-open");

            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                document.body.removeChild(backdrop);
            }
        }

        return () => {
            document.body.classList.remove("modal-open");

            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                document.body.removeChild(backdrop);
            }
        };
    }, [show]);

    const handleSubmit = () => {
        if (!priceGuess) {
            toast.error("Please Enter the Price!");
            return;
        }

        if (!reason) {
            toast.error("Please Enter the Reason!");
            return;
        }

        onSubmit({ price: priceGuess, reason });
        handleClose();
    };

    if (!show) return null;

    return (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    exit={{ scale: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    className="modal-content rounded-lg shadow-lg"
                >
                    {/* Modal Header */}
                    <div className="modal-header border-0 justify-center pt-4 pb-2 relative">
                        <div className="tw-flex tw-justify-self-center !tw-justify-center !tw-items-center">
                            <BsCashCoin className="tw-h-7 tw-w-7" />
                            <h5 className="modal-title tw-text-xl tw-font-bold tw-ml-2 tw-text-center">
                                Your Guess: {String(guess).toUpperCase()}
                            </h5>
                        </div>
                        <button
                            type="button"
                            className="absolute right-4 top-4 bg-transparent border-0 text-black"
                            onClick={handleClose}
                        >
                            <X className="tw-h-7 tw-w-7" />
                        </button>
                    </div>

                    {/* Modal Body */}
                    <div className="modal-body p-4">
                        <p className="tw-text-lg">What do you think the final sale price will be?</p>
                        <input
                            type="number"
                            className="form-control p-3 border rounded-lg w-full mb-3"
                            placeholder="Enter the Price"
                            value={priceGuess}
                            onChange={(e) => setPriceGuess(e.target.value)}
                        />
                        <textarea
                            className="form-control p-3 border rounded-lg w-full"
                            placeholder="What makes you think that?"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        ></textarea>
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer tw-border-0 tw-justify-center p-4">
                        <button
                            type="button"
                            className="tw-w-3/4 tw-py-3 tw-px-4 tw-bg-[#F69929] tw-text-black tw-font-bold tw-rounded-full"
                            onClick={handleSubmit}
                        >
                            Guess
                        </button>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default GuessPriceModal;
